__webpack_require__.p = "/2025/labs/bottrop/students/annasophia-brokuf/";